import { trace } from 'rytm-helpers'
import { gsap, TweenLite, TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1, Power2, Power3, Power4 } from 'gsap'


const onAnimationComplete = () => {
  document.documentElement.classList.remove("index-loading")
}

export const loadingAnimationStart = () => {
  const loading = document.getElementById("index-loading")
  if (!loading) {
    onAnimationComplete()
    return
  }
  trace("loading animation start")
  const a = new TimelineMax({repeat: 0})
  a.set(loading, {y: 0, x: 0, opacity: 1})
  a.to(loading, .4, {opacity: 0, delay: .15, onComplete: onAnimationComplete})  
}